import type { Component } from "vue";
import type { DecorationIcon } from "#ui/decoration/types";
import CartBoxIcon from "./cartBoxIcon/CartBoxIcon.vue";
import CartRemoveClose from "./cartRemoveClose/CartRemoveClose.vue";
import CartStepperText from "./cartStepperText/CartStepperText.vue";

export interface CartBoxIconControl {
	icon: DecorationIcon | null;
	fallback: string;
}

export interface CartStepperControl extends CartBoxIconControl {
	label: string;
}

export const CART_STEPPER_DEFAULT = "text";
export const CART_REMOVE_DEFAULT = "close";

export const cartStepperVariants: Record<string, Component> = {
	text: CartStepperText,
	icon: CartBoxIcon,
};

export const cartRemoveVariants: Record<string, Component> = {
	close: CartRemoveClose,
	cross: CartBoxIcon,
};
